import * as React from 'react'

import { FormWidget, FormConfigurations } from 'jimbo/ui/Forms'
import TextField from 'jimbo/ui/TextField'
import DateTimeField from 'jimbo/ui/DateTimeField'


import SelectExperienceWidget from './SelectExperienceWidget'
import SelectImageWidget from './SelectImageWidget'
import BooleanField from 'jimbo/ui/BooleanField'

const promotionFormConfigurationsData = {
    "Promotion": {
        fields: [
            { 
                fieldName: "name", 
                label: "Name", 
                widget: TextField 
            },
            { 
                fieldName: "isDefault", 
                label: "Default", 
                widget: BooleanField 
            },
            {
                fieldName: "publishStartDateTime",
                label: "Start date",
                widget: DateTimeField
            },
            {
                fieldName: "publishEndDateTime",
                label: "End date",
                widget: DateTimeField
            },
            {
                fieldName: "publishedContentObject",
                label: "Storytrail",
                widget: SelectExperienceWidget,
            },
            {
                fieldName: "promotionUrl",
                label: "Website url",
                widget: TextField
            },
            {
                fieldName: "imageContainer",
                label: "Image",
                widget: SelectImageWidget
            },
        ]
    }
}


const promotionFormConfigurations = new FormConfigurations(promotionFormConfigurationsData)


const PromotionForm = ({ instance, store }) => {
    return <React.Fragment>
        <FormWidget label="Notification" instance={instance} formConfigurations={promotionFormConfigurations} store={store}/>
    </React.Fragment>
}


export default PromotionForm